export const slugify = (str: string): string => {
  const slug = str
    .toLowerCase()
    .replace(/[^a-z0-9\u0600-\u06FF]+/g, '-')
    .replace(/^-+|-+$/g, '-');
  return encodeURIComponent(slug);
};

export function truncateHtml(html: string, maxLength: number): string {
  const text = html.replace(/<[^>]+>/g, '');
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
}

export function strLimit(string: string = '', limit: number = 20): string {
  string = String(string || '');
  if (string.length <= limit) {
    return string;
  }
  return string.slice(0, limit) + '...';
}

export function removeHtml(string: string = '', limit: number = 20): string {
  string = String(string || '');
  string = string
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ');
  string = string.replace(/<[^>]+>/g, '');
  string = string.replace(/\s+/g, ' ').trim();
  if (string.length <= limit) {
    return string;
  }
  return string.slice(0, limit) + '...';
}

export function capitalize(str: string) {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function numberToWords(num: number): string {
  const yekan: string[] = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
  const dahgan: string[] = ["", "", "بیست", "سی", "چهل", "پنجاه", "شصت", "هفتاد", "هشتاد", "نود"];
  const sadgan: string[] = ["", "یکصد", "دویست", "سیصد", "چهارصد", "پانصد", "ششصد", "هفتصد", "هشتصد", "نهصد"];
  const dah: string[] = ["ده", "یازده", "دوازده", "سیزده", "چهارده", "پانزده", "شانزده", "هفده", "هجده", "نوزده"];

  if (num === 0) return "صفر";

  let result = "";
  let i = 0;
  const parts: string[] = ["", " هزار", " میلیون", " میلیارد"];

  while (num > 0) {
    let part = num % 1000;
    if (part > 0) {
      let s = "";
      if (part >= 100) {
        s += sadgan[Math.floor(part / 100)] + " و ";
        part %= 100;
      }
      if (part >= 20) {
        s += dahgan[Math.floor(part / 10)] + " و ";
        part %= 10;
      }
      if (part >= 10) {
        s += dah[part - 10] + " و ";
      } else if (part > 0) {
        s += yekan[part] + " و ";
      }
      result = s.slice(0, -3) + parts[i] + (result ? " و " : "") + result;
    }
    num = Math.floor(num / 1000);
    i++;
  }

  return result.trim();
}
